module.exports = __webpack_public_path__ + "img/2.0675a737.png";